export default {
	computed: {
		models() {
			return [ 
				'aseguradora',
				'asegurado',
				'amortizacion',
				'cobertura',
				'resolucion_siniestro',
				'posible_causa',
				'color_siniestro',
				'tipo_producto_de_seguro',
				'ramo',
				'gestor_scrap_free',
				'gestor_aseguradora',
				'tecnico',
				'linea',
				'sub_linea',
				'causa_siniestro',
				'estado_general_siniestro',
				'estado_siniestro',
				'estado_bien',
				'causa_bien',
				'tipo_orden_de_servicio',
				'unidad_negocio',
				'honorario_liquidacion',
				'provincia',
				'localidad',
			]
		},
	}
}